import Vue from 'vue'
import Router from 'vue-router'

// Containers
const HomeContainer = () => import('@/layouts/HomeContainer')
const DefaultContainer = () => import('@/layouts/DefaultContainer')

const Dictionary = () => import('@/pages/Dictionary')
const Home = () => import('@/pages/Home')
const About = () => import('@/pages/About')
const Body = () => import('@/components/corpora/CorporaSearch')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'index',
      component: HomeContainer,
      children: [
        {
          path: 'home',
          name: 'home',
          meta: {
            label : "Главная",
            title : "Национальный корпус удмуртского языка"
          },
          component: Home
        }
      ]
    },
    {
      path: '/dictionary',
      component: DefaultContainer,
      children:[
        {
          path: '',
          name: 'dictionary',
          meta: {
            label : "Словарь",
            title : "Национальный корпус удмуртского языка - Словарь"
          },
          component: Dictionary
        }
      ]
    },
    {
      path: '/body',
      component: DefaultContainer,
      children:[
        {
          path: '',
          name: 'body',
          meta: {
            label : "Корпус",
            title : "Основной корпус"
          },
          component: Body
        }
      ]
    },
    {
      path: '/memorials',
      component: DefaultContainer,
      children:[
        {
          path: '',
          name: 'body',
          meta: {
            label : "Корпус",
            title : "Корпус письменных памятников"
          },
          component: Body
        }
      ]
    },
    {
      path: '/about',
      component: DefaultContainer,
      children:[
        {
          path: '',
          meta: {
            label : "О проекте",
            title : "Национальный корпус удмуртского языка - О проекте"
          },
          component: About
        }
      ]
    }
  ]
})
